var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4"},[_c('h5',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm._f("setText")("canceled","Отменено")))])])}
var staticRenderFns = []

export { render, staticRenderFns }